import script from "./PhotoGalleryList.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotoGalleryList.vue?vue&type=script&setup=true&lang=js"

import "./PhotoGalleryList.vue?vue&type=style&index=0&id=18e03582&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18e03582"]])

export default __exports__